import React from 'react'

const Tabs = ({ heading, active, onTabSelect }) => {
  return (
    <div className="inline-flex p-1 bg-surface-100 rounded-xl">
      {heading && heading.map((_heading, index) => (
        <button
          key={index}
          onClick={onTabSelect}
          className={`
            px-5 py-2.5 rounded-lg text-sm font-semibold
            transition-all duration-200 ease-out
            ${_heading === active
              ? 'bg-white text-surface-800 shadow-soft'
              : 'text-surface-500 hover:text-surface-700'
            }
          `}
        >
          {_heading}
        </button>
      ))}
    </div>
  )
}

export default Tabs
